import React from "react";
import { Box, Typography } from "@mui/material";

interface MetricSummaryRowProps {
  label: string;
  children: React.ReactNode;
}

/** Label-left, value-right row for a metric's read-only "Saved definition"
 *  summary (Bar Chart's creation modal and editor drawer) — the label column
 *  stays a fixed width so multi-line values (e.g. a question's label plus
 *  its full title) wrap left-aligned in the remaining space instead of
 *  stacking under the label. */
const MetricSummaryRow: React.FC<MetricSummaryRowProps> = ({ label, children }) => (
  <Box sx={{ display: "flex", gap: 2 }}>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ flexShrink: 0, width: 120, pt: "1px" }}
    >
      {label}
    </Typography>
    <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
  </Box>
);

export default MetricSummaryRow;
